import axios from "axios";
import {isEmpty} from "lodash";
import moment from "moment-timezone";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const getSupportChatParams = (fingerprint, isMedical = false) => {
  return {
    channel: isMedical ? "CUSTOMER_MEDICAL" : "CUSTOMER",
    device_platform: "WEB",
    device_id: fingerprint,
    notificationId: null,
  };
};

const registerSupportChat = async (fingerprint, isMedical) => {
  if (isEmpty(fingerprint)) {
    throw new Error("Device fingerprint not found.  Disable adblockers/privacy extensions to chat with support");
  }
  console.log("📢[chat.services.js:16]: registerSupportChat");
  return (
    await axios.post(`${API_URL}/api/1/chat/in_app/register_device`, {
      ...getSupportChatParams(fingerprint, isMedical),
    })
  )?.data;
};

const sendMessageProviderChat = async (threadId, content) => {
  const result = await axios.put(
    `${API_URL}/api/1/conversation/${threadId}`,
    {
      content,
      local_timestamp: moment().toISOString(),
    },
    {}
  );
  return result;
};

const registerProviderChat = async (appointmentId) => {
  console.log("📢[chat.services.js:16]: registerProviderChat");
  return (
    await axios.get(`${API_URL}/api/1/conversation`, {
      params: {
        appointment_id: appointmentId,
        type: "client",
      },
    })
  )?.data?.id;
};
const getUnreadCountSupportChat = async (fingerprint, isMedical) => {
  console.log("📢[chat.services.js:16]: getUnreadCountSupportChat");
  return (
    await axios.get(`${API_URL}/api/1/chat/in_app/messages/unread`, {
      params: getSupportChatParams(fingerprint, isMedical),
    })
  )?.data?.unread_count;
};

const clearUnreadCountSupportChat = async (fingerprint, isMedical) => {
  console.log("📢[chat.services.js:16]: clearUnreadCountSupportChat");
  return (
    await axios.put(`${API_URL}/api/1/chat/in_app/messages/unread`, {
      params: getSupportChatParams(fingerprint, isMedical),
    })
  )?.data?.unread_count;
};

const getMessagesSupportChat = async (
  fingerprint,
  { dateSince, dateUntil, pageSize, isMedical }
) => {
  console.log("📢[chat.services.js:16]: getMessagesSupportChat");
  const messages = (
    await axios.get(`${API_URL}/api/1/chat/in_app/messages`, {
      params: {
        ...getSupportChatParams(fingerprint, isMedical),
        date_since: moment(dateSince).toISOString(),
        date_until: moment(dateUntil).toISOString(),
        page_size: pageSize,
        is_descending_order: true,
      },
    })
  )?.data?.list;
  const deduped = (messages ?? []).filter(
    (v, i, a) => a.findIndex((t) => t.id === v.id) === i
  );
  return deduped;
};

function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => formData.append(key, object[key]));
  return formData;
}

const sendMessageSupportChat = async (fingerprint, message, attachment, isMedical, payload) => {
  const params = {
    ...getSupportChatParams(fingerprint, isMedical),
    text: message,
    support_context_raw: JSON.stringify(payload)

  }
  let formData = getFormData(params);
  if (attachment) {
    formData.append("attachment_file", attachment);

  }
  const result = await axios.post(
    `${API_URL}/api/1/chat/in_app/messages`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }
  );
  return result;
};

export {
  registerProviderChat,
  sendMessageProviderChat,
  sendMessageSupportChat,
  registerSupportChat,
  getUnreadCountSupportChat,
  clearUnreadCountSupportChat,
  getMessagesSupportChat,
};
